
export const CAMPAIGN_BREADCRUMB = [
  { title: 'Inicio', to: '/' },
  { title: 'Campañas' },
];

export const CAMPAIGN_DEFAULTS = {
  nombre: 'Sin nombre',
  alias: 'Sin alias',
  template: 'Sin template',
  estado: 'unknown',
  totalContactos: 0,
};

export const UPLOAD_TYPES = {
  CONTACTS: 'contacts',
  FILE: 'file',
  CATEGORIES: 'categories',
};

export const CAMPAIGN_STATUS = {
  SCHEDULED: 'SCHEDULED',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  LAUNCHED: 'LAUNCHED',
};

export const CAMPAIGN_STATUS_COLORS = {
  [CAMPAIGN_STATUS.SCHEDULED]: 'primary',
  [CAMPAIGN_STATUS.PENDING]: 'info',
  [CAMPAIGN_STATUS.COMPLETED]: 'warning',
  [CAMPAIGN_STATUS.LAUNCHED]: 'success',
  [CAMPAIGN_STATUS.CANCELLED]: 'error',
};


export const canEditCampaign = (status) => {
  return status === CAMPAIGN_STATUS.PENDING;
};


export const canDeleteCampaign = (status) => {
  return status === CAMPAIGN_STATUS.SCHEDULED || status === CAMPAIGN_STATUS.PENDING;
};


export const canLaunchCampaign = (status) => {
  return status === CAMPAIGN_STATUS.PENDING;
};

export const CAMPAIGN_STATUS_LABELS = {
  [CAMPAIGN_STATUS.SCHEDULED]: 'Programado',
  [CAMPAIGN_STATUS.PENDING]: 'Pendiente',
  [CAMPAIGN_STATUS.LAUNCHED]: 'Lanzado',
  [CAMPAIGN_STATUS.COMPLETED]: 'Completado',
  [CAMPAIGN_STATUS.CANCELLED]: 'Cancelado',
};


export const ALLOWED_FILE_TYPES = ['.csv', '.xlsx', '.txt'];

export const ALLOWED_MIME_TYPES = [
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/plain',
];

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB en bytes


export const MAX_CONTACTS_PER_TEMPLATE = 2000;

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

// Template constants
export const TEMPLATE_STATUS = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED',
};


export const TEMPLATE_CATEGORY = {
  UTILITY: 'UTILITY',
  MARKETING: 'MARKETING',
  AUTHENTICATION: 'AUTHENTICATION',
};

export const TEMPLATE_STATUS_STYLES = {
  [TEMPLATE_STATUS.APPROVED]: {
    backgroundColor: '#E8F5E9',
    color: '#2E7D32',
    label: 'Aprobado',
  },
  [TEMPLATE_STATUS.PENDING]: {
    backgroundColor: '#FFF3E0',
    color: '#EF6C00',
    label: 'Pendiente',
  },
  [TEMPLATE_STATUS.REJECTED]: {
    backgroundColor: '#FFEBEE',
    color: '#C62828',
    label: 'Rechazado',
  },
  [TEMPLATE_STATUS.FAILED]: {
    backgroundColor: '#FDECEA',
    color: '#C62828',
    label: 'Fallido',
  },
};


export const TEMPLATE_CATEGORY_STYLES = {
  [TEMPLATE_CATEGORY.UTILITY]: {
    backgroundColor: '#f2f2ff',
    color: '#0016ff',
    label: 'Utilidad',
  },
  [TEMPLATE_CATEGORY.MARKETING]: {
    backgroundColor: '#f6f3ff',
    color: '#4700ff',
    label: 'Marketing',
  },
  [TEMPLATE_CATEGORY.AUTHENTICATION]: {
    backgroundColor: '#f9f0ff',
    color: '#8c00ff',
    label: 'Autenticación',
  },
};


export const TEMPLATE_CATEGORY_LABELS = {
  [TEMPLATE_CATEGORY.UTILITY]: 'Utilidad',
  [TEMPLATE_CATEGORY.MARKETING]: 'Marketing',
  [TEMPLATE_CATEGORY.AUTHENTICATION]: 'Autenticación',
};

//messages details
export const MESSAGE_STATUS = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  FAILED: 'FAILED',
  READ: 'READ',
};

export const MESSAGE_STATUS_LABELS = {
  [MESSAGE_STATUS.PENDING]: 'Pendiente',
  [MESSAGE_STATUS.SENT]: 'Enviado',
  [MESSAGE_STATUS.DELIVERED]: 'Entregado',
  [MESSAGE_STATUS.FAILED]: 'Fallido',
  [MESSAGE_STATUS.READ]: 'Leído',
};

export const MESSAGE_STATUS_COLORS = {
  [MESSAGE_STATUS.PENDING]: 'warning',
  [MESSAGE_STATUS.SENT]: 'info',
  [MESSAGE_STATUS.DELIVERED]: 'success',
  [MESSAGE_STATUS.FAILED]: 'error',
  [MESSAGE_STATUS.READ]: 'primary',
};

// pricing de campañas
export const formatUSD = (amount) => {
  if (typeof amount !== 'number') return '$0.00 USD';
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(amount);
};
  
export const META_PRICING_DOCS_URL = 'https://developers.facebook.com/docs/whatsapp/pricing';